import { useLocation, useNavigate } from 'react-router-dom';
import AppContext from '../components/AppContext';
import { useContext } from 'react';

function useBack() {
  const { ctxApp }  = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  
  const onBack = () => {
    const defaultPath = ctxApp.firstPage || '/'
    if (location.pathname === defaultPath) {
        navigate(defaultPath, { replace: true });
    } else {
        navigate(-1);
    }
  };

  return { onBack };
}

export default useBack;
